import React from "react";
import * as Mui from "@mui/material";
import * as env from "shared/env";
import { useCSVReader } from 'react-papaparse';
import { User } from "model/user";

interface Headers {
	email: string;
	name?: string;
	address?: string;
	state?: string;
	phone?: string;
	city?: string;
	zip?: string;
	birthday?: string; 
	type?: string; 
	agentid?: string; 
	anniversary?: string; 
	pipeline?: string; 
	tags?: string; 
	note?: string; 
	texting?: string;
	marketids?: string;
	campaignids?: string;
	source?: string;
}

interface Props {
	user: User;
	onUpload: (results: Headers[], invalidHeaders: {header: string; info: string; }[]) => void;
	buttonLabel?: string;
	disabled?: boolean;
	onFileAccepted?: (file: File) => void;
}

const Component: React.FC<Props> = (props) => {
	const { onUpload, buttonLabel, disabled, onFileAccepted } = props;
	const { CSVReader } = useCSVReader();
	const lastAcceptedFileRef = React.useRef<string | undefined>(undefined);
	const processHeader = (header: string) => {
		return header.replace(/\s/g,'').toLowerCase();
	}
	const validate = (headerRow: any) => {
		const exclude: { header: string; info: string }[] = [];
		type Columns = (keyof Headers);
		const headers: Columns[] = [
			"email",
			"name",
			"address",
			"state",
			"phone",
			"city",
			"zip",
			"birthday", 
			"type", 
			"agentid",  
			"anniversary", 
			"pipeline", 
			"tags", 
			"note", 
			"texting",
			"marketids",
			"campaignids",
			"source",
		];
		for (let [key] of Object.entries(headerRow)) {
			if (!headers.includes(key as Columns)) {
				exclude.push({header: key, info: "Invalid column name."});
			}
			if (!props.user.admin && key === "agentid" as Columns) {
				exclude.push({header: key, info: "Only administrators are allowed to assign agents. The imported leads will be assigned to you."});
			}
		}
		return exclude;
	}
	return (
		<CSVReader
			config={
				{
					header: true,
					skipEmptyLines: 'greedy',
					transformHeader: (header: string) => processHeader(header),
				}
			}
			onUploadAccepted={(results: any) => {
				const invalidHeaders = validate(results.data[0]);
				onUpload(results.data, invalidHeaders);
			}}
			
		>
			{({
				getRootProps,
				acceptedFile,
				ProgressBar,
				getRemoveFileProps,
			}: any) => (
				<React.Fragment>
					{acceptedFile &&
						onFileAccepted &&
						acceptedFile.name !== lastAcceptedFileRef.current &&
						(() => {
							lastAcceptedFileRef.current = acceptedFile.name;
							onFileAccepted(acceptedFile);
							return null;
						})()}
					<Mui.Grid container direction="column" spacing={1}>
						<Mui.Grid container spacing={1} justifyContent="flex-end">
							<Mui.Grid item>
								<Mui.Button variant="contained" color={"primary"} {...getRootProps()} disabled={disabled}>
										{buttonLabel ? buttonLabel : "Browse File"}
								</Mui.Button>
							</Mui.Grid>
						</Mui.Grid>
						<Mui.Grid item>
							<ProgressBar />
						</Mui.Grid>
					</Mui.Grid>
				</React.Fragment>
			)}
		</CSVReader>
	);
};

export const CsvReader = Component;

